import api from "../api/api";

/**
 * İstifadəçi abunəlik sistemi.
 * Ödənişli paketdə backend bank ödəniş səhifəsinin URL-ini qaytarır —
 * istifadəçi ora yönləndirilir, ödənişdən sonra /subscription?payment=... ünvanına qayıdır.
 */
export const SubscriptionService = {
  // Public — qiymət səhifəsi üçün (login tələb olunmur)
  plans: async () => {
    const response = await api.get("customer-plans");
    return response.data; // { plans: [...], required, gate }
  },

  // Cari abunəlik vəziyyəti
  my: async () => {
    const response = await api.get("customer/subscription");
    return response.data;
  },

  // Paket seç → { status: "activated" | "payment_required", payment_url? }
  subscribe: async ({ planId, periods = 1, saveCard = false }) => {
    const response = await api.post("customer/subscription", {
      plan_id: planId,
      periods,
      save_card: saveCard,
    });
    return response.data;
  },

  // Yarımçıq qalmış sorğunun ödənişini yenidən başlat
  pay: async ({ saveCard = false } = {}) => {
    const response = await api.post("customer/subscription/pay", {
      save_card: saveCard,
    });
    return response.data;
  },

  cancelRequest: async () => {
    const response = await api.post("customer/subscription/cancel-request");
    return response.data;
  },

  setAutoRenew: async (value) => {
    const response = await api.post("customer/subscription/auto-renew", {
      auto_renew: value,
    });
    return response.data;
  },

  removeCard: async () => {
    const response = await api.delete("customer/subscription/card");
    return response.data;
  },

  history: async () => {
    const response = await api.get("customer/subscription/history");
    return response.data; // { subscriptions: [...], requests: [...] }
  },
};

/** Backend abunəlik tələb etdikdə 402 + code=subscription_required qaytarır */
export const isSubscriptionError = (error) =>
  error?.response?.status === 402 ||
  error?.response?.data?.code === "subscription_required";
